import * as moment from 'moment';
import * as _ from 'lodash';
import { ICalendarShift, CalendarService } from "../../services/calendar.service";
import { AuthService } from "../../authorization/services/index";
import { ShiftService } from "../../services/index";

class ScheduleCalendarController {
    statuses: any;
    private shifts: ICalendarShift[];
    private employeeId: string;
    private uiConfig: any;
    private eventSources: any = [];
    private isEmployee: boolean;
    
    constructor(private CalendarService: CalendarService,
        private AuthService: AuthService,
        private ShiftService: ShiftService,
        private $state: ng.ui.IStateService,
        private uiCalendarConfig: any,
        private $scope: ng.IScope,
        private $compile : ng.ICompileService,
        private $sce: ng.ISCEService,
        private screenSize: any
    ) {
        "ngInject";
    }

    public $onInit = () => {
        // this.employeeId = this.AuthService.getEmployeeId(this.AuthService.GetAuthorizationData());

        this.eventSources = [this.getEvents];

        this.uiConfig = {

            calendar: {

                height: 700,
                locale: 'nl',
                header: {
                    left: 'title',
                    right: ' prev,next month,agendaWeek,agendaDay'
                },
                buttonIcons: {
                    prev: ' fa fa-caret-left',
                    next: ' fa fa-caret-right',
                },
                displayEventEnd: false,

                axisFormat: 'h:mm',

                allDaySlot: false,
                timeFormat: 'H:mm',
                eventLimit: false,
                eventClick: this.openItem,
                //eventDrop: $scope.alertOnDrop,
                //eventResize: $scope.alertOnResize,
                eventRender: this.eventRender
            }
        };

        this.ShiftService.subscribe('ScheduleCalendarController', (type) => {
            var newShift;
            var calendarItem;
            switch (type) {
                case 'post': {
                    newShift = this.ShiftService.item;
                    calendarItem = new ICalendarShift();
                    calendarItem.start = newShift.start;
                    calendarItem.end = newShift.end;
                    calendarItem.status = newShift.status.toString();
                    calendarItem.statusColor = newShift.statusColor;
                    calendarItem.title = newShift.teamLocationName;
                    calendarItem.shift = newShift;
                    this.shifts.push(calendarItem);
                    break;
                }
                case 'put': {
                    this.shifts = this.shifts.filter(s => s.shift.id !== newShift.id);
                    if (this.ShiftService.item.status !== 99) {
                        newShift = this.ShiftService.item;
                        calendarItem = new ICalendarShift();
                        calendarItem.start = newShift.start;
                        calendarItem.end = newShift.end;
                        calendarItem.status = newShift.status.toString();
                        calendarItem.statusColor = newShift.statusColor;
                        calendarItem.title = newShift.teamLocationName;
                        calendarItem.shift = newShift;
                        this.shifts.push(calendarItem);
                    }                    
                    break;
                }
                case 'delete': {
                    this.shifts = this.shifts.filter(s => s.shift.id !== this.ShiftService.itemId);
                    break;
                }
            }

            this.uiCalendarConfig.calendars['scheduleCalendar'].fullCalendar('refetchEvents');
        });

        if (this.AuthService.hasRole("employee")) {
            this.isEmployee = true;
        } else {
            this.isEmployee = false;
        }
    }

    private openItem = (event, jsEvent) => {
        $(jsEvent.currentTarget).tooltip('hide');
        switch (event.type) {
            case 'shift': 
                if(event.item.comment == "Aangemaakt door gebruiker!"){
                this.$state.go('schedule.list.item', { 'id': event.item.id, 'start': event.item.start });
                } else {
                this.$state.go('schedule.list.item', { 'id': event.item.id, 'start': event.item.start });
                }
                break;
            case 'availability':
                this.$state.go('schedule.calendar.availability', { 'availabilityId': event.item.id });
                break;
            case 'subscription':
                this.$state.go('schedule.calendar.subscription', { 'employeeId': '', 'subscriptionId': event.item.id });
                break;
        }
       
    }
    private eventRender = (event, element, view) => {
        var status : any = _.find(this.statuses, {code: event.status});
        var statusName = status ? status.name:  "";
        var eventTitle = event.title + " - " + event.item.teamName + "<br /><b>" + statusName + "</b>";

        var color: string;
        switch (event.type) {
            case 'shift': 
                if (this.isEmployee && event.item.declarations.length > 0) {
                    color = '#165B68'; // @brand-info darker shade
                    eventTitle = event.title + " - " + event.item.teamName + "<br /><b>Gedeclareerd</b>";
                } else {
                    color = '#4cc3d9'; // @brand-info
                }
                break;
            case 'availability':
                if (event.title.toLowerCase() == 'beschikbaar') {
                    color = '#2ECC71'; // @brand-success
                    eventTitle = event.title + "<br /><b>Beschikbaar</b>";
                } else {
                    color = '#d96557'; // @brand-danger
                    eventTitle = event.title + "<br /><b>Niet beschikbaar</b>";
                }
                break;
            case 'subscription':
                eventTitle = event.title + "<br /><b>Ingeschreven</b>";
                color = '#ffc65d'; // @brand-warning
                //element.hide();
                break;
        }

        if (moment().isBefore(event.start)) {
            element.css({ 'background-color': color, 'border-color': color });
        } else {
            element.css({ 'background-color': color, 'border-color': color, 'opacity': 0.7 });
        }

        element.tooltip({container: "body", title: eventTitle, placement: "top", html:true }); 
        var title = element.find('.fc-title, .fc-list-item-title');          
        title.html(eventTitle);

        this.$compile(element)(this.$scope);
    }

    private getEvents = (start, end, timezone, callback) => {
        // console.log('getEvents');
        this.CalendarService.customAll('employee', { 'start': start.toDate() , 'end': end.toDate() }).then((events) => {
            //filter out canceld shifts
            events = _.reject(events, {"status" : "92"});
            events = _.reject(events, {"title" : null});
            this.shifts = events;
            callback(events);
        });
    }
}

export const scheduleCalendarComponent = {
    bindings: {
        statuses: "<"
    },
    controller: ScheduleCalendarController,
    template: require('./schedule.calendar.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/schedule/schedule.calendar.component.ts